import {closeCurrentDialog, openDialog} from 'platform/components';

import {BillingInformationDifferenceResponseBody, BillingInformationSource} from '@dms/api/sales';
import i18n from '@dms/i18n';

import {BillingInformationMismatchDialog} from './BillingInformationMismatchDialog';

export function openBillingInformationMismatchDialog(
  differences: BillingInformationDifferenceResponseBody[]
) {
  return new Promise<BillingInformationSource | undefined>((resolve) => {
    const handleSelect = (source: BillingInformationSource) => {
      resolve(source);
      closeCurrentDialog();
    };

    openDialog(
      <BillingInformationMismatchDialog differences={differences} onSelect={handleSelect} />,
      {
        title: i18n.t('entity.businessCase.billingInformationComparison.title'),
        hideCloseButton: true,
        onCloseComplete: () => resolve(undefined),
      }
    );
  });
}
